<template>
  <authorization permissionKey="configuration_facilitator_medication_history" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Frequência de história medicamentosa
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <MedicationHistoryList
            :facilitators="medicationHistoryFrequencies"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import MedicationHistoryList from "@/components/config/medication_history/list/index.vue";

  export default {
    name: "MedicationHistoryConfig",
    components: {
      MedicationHistoryList,
    },
    apollo: {
      medicationHistoryFrequencies: {
        query: require("@/graphql/medication_history_frequencies.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.medicationHistoryFrequencies.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
